export enum ArticleLabelTypes {
  RoundWithProductName = 'RoundWithProductName',
  EAN = 'EAN',
  Round58x58 = 'Round58x58',
  Round50x25 = 'Round50x25',
  Round50x50 = 'Round50x50',
  FremdmarkeNutrition = 'FremdmarkeNutrition',
}

export const INSTANT_ARTICLE_LABEL_TYPES: ArticleLabelTypes[] = [
  ArticleLabelTypes.EAN,
  ArticleLabelTypes.RoundWithProductName,
];

export function isInstantArticleLabelType(type: string): boolean {
  return INSTANT_ARTICLE_LABEL_TYPES.includes(type as ArticleLabelTypes);
}

export enum ArticleLabelTypesDisplayNames {
  RoundWithProductName = 'Rund mit Produktname',
  EAN = 'EAN',
  Round58x58 = '58x58 mm',
  Round50x25 = '50x25 mm',
  Round50x50 = '50x50 mm',
  FremdmarkeNutrition = 'Fremdmarke mit Nährwerten',
}
